import { render, staticRenderFns } from "./circulateItem.vue?vue&type=template&id=0b03af04&scoped=true"
import script from "./circulateItem.vue?vue&type=script&lang=js"
export * from "./circulateItem.vue?vue&type=script&lang=js"
import style0 from "./circulateItem.vue?vue&type=style&index=0&id=0b03af04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b03af04",
  null
  
)

export default component.exports